<template>
  <div class="order-list">
    <div :class="{ 'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187 }"></div>
    <div class=" order-list-main">
      <div class="controller-container">
        <div class="controller-content">
          <div class="el-input">
            <el-select v-model="deliveryManIndex" placeholder="">
              <el-option label="诚智物流" value=""></el-option>
            </el-select>
            <el-select v-model="order" @change="selectTrigger(order)">
              <el-option
                v-for="item in orderList"
                :key="item.id"
                :label="item.name"
                :value="item.link"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBgHeaderH187: false,
      deliveryManIndex: "",
      orderList: [
        {
          name: "仓库信息",
          link: "https://admin.chengzhiwuliu.cn/third/storage/list",
        },
        {
          name: "仓库视频",
          link: "https://admin.chengzhiwuliu.cn/third/storage/video",
        },
        {
          name: "入库订单",
          link: "https://admin.chengzhiwuliu.cn/third/order/list",
        },
        {
          name: "配送记录",
          link: "https://admin.chengzhiwuliu.cn/third/delivery/list",
        },
      ],
      order:""
    };
  },
  created() {},
  mounted() {},
  methods: {
      selectTrigger(order){
       window.open(order);
      }
  },
};
</script>

<style scoped>
@import url(../../assets/css/base.css);
.order-list-main {
  position: relative;
  top: -63px;
  background-color: transparent;
  margin: 10px auto;
}
.bg-head-nav {
  background-color: #d2f5e8;
  height: 64px;
}
.bg-head-h187 {
  height: 187px;
}
.el-input {
  /* width: 230px; */
  margin-left: 20px;
}
.el-select-dropdown__wrap .el-scrollbar__wrap {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/OrderServiceProvider.vue